import { useResetAutoSelectionOnUnmount } from '@/pages/product-selection';

import { MainLayout } from './MainLayout';

export const AutoSelectionLayout = () => {
  useResetAutoSelectionOnUnmount();

  return <MainLayout />;
};
